// Planillas que ofrece la vista de exportadores; `url` es el nombre con que
// las identifica el backend.
export const EXPORTADORES = [
    {   title: "Supervisores",
        icon: "mdi-account-supervisor",
        url: "supervisores",
        descripcion: "Nombre, correo y empresa de los supervisores de los prácticantes"
    },
    {   title: "Prácticas en curso",
        icon: "mdi-progress-clock",
        url: "practicas_en_curso",
        descripcion: "Datos de los alumnos y de las prácticas que se encuentran en curso en el periodo indicado"
    },
    {   title: "Prácticas Aprobadas",
        icon: "mdi-check-circle",
        url: "practicas_aprobadas",
        descripcion: "Datos de los alumnos y de las prácticas que se encuentran en aprobadas en el periodo indicado"
    },
    {   title: "Prácticas Convalidadas",
        icon: "mdi-text-box-check",
        url: "practicas_convalidadas",
        descripcion: "Datos de los alumnos y de las prácticas que se hayan sido convalidadas"
    },
    {   title: "Jefes de RRHH",
        icon: "mdi-account-tie",
        url: "jefes_rrhh",
        descripcion: "Nombre, correo y empresa de los jefes de RRHH de los prácticantes"
    },
    {   title: "Empresas y alumnos",
        icon: "mdi-domain",
        url: "empresas_alumnos",
        descripcion: "Cada empresa con los alumnos que hicieron su práctica en ella: nombre, rut, rol, tipo de práctica y fecha de inicio"
    },
    {   title: "Comentarios de Alumnos",
        icon: "mdi-comment-account",
        url: "comentarios_alumnos",
        descripcion: " Incluye comentarios al DI y comentarios Sistema de Prácticas"
    },
    {   title: "Notas alumnos anonimos",
        icon: "mdi-clipboard-list",
        url: "notas_alumnos_anonimos",
        descripcion: "Incluye las notas puestas en la evaluación del alumno sin información personal"
    },
    {   title: "Notas alumnos con nombre",
        icon: "mdi-clipboard-list",
        url: "notas_alumnos",
        descripcion: "Incluye las notas puestas en la evaluación del alumno con nombre, rut y rol"
    },
    {   title: "Alumnos con marcas",
        icon: "mdi-flag",
        url: "alumnos_marcas",
        descripcion: "Incluye información con las marcas puestas entre las fechas indicadas, vienen negativas, neutras y positivas"
    },
    {   title: "Alumnos con riesgos",
        icon: "mdi-alert-circle",
        url: "alumnos_riesgos",
        descripcion: "Incluye información de los alumnos cuya práctica fue marcada con reparos por el supervisor o tienen una nota alarmante"
    },
];
